import { InputLabel, RadioGroup, Typography, Box } from "@mui/material";
import { red } from "@mui/material/colors";
import { Fragment } from "react";

function RadioInput1({ label, errors, name, children, errText, ...rest }) {
  return (
    <Fragment>
      {label && (
        <InputLabel variant="specialistSignup">
          {label}
        </InputLabel>
      )}
      <Box sx={{ mt: 1 }}>
        <RadioGroup row name={name} {...rest}>
          {children}
        </RadioGroup>
      </Box>
      {errors?.[name] && (
        <Typography mt={1} color={red["500"]}>
          {errText}
        </Typography>
      )}
    </Fragment>
  );
}

export default RadioInput1;